var map = {
	"./basketball-active.webp": 1538,
	"./basketball.webp": 1539,
	"./bg.webp": 1540,
	"./football-active.webp": 1541,
	"./football.webp": 1542,
	"./games-active.webp": 1543,
	"./games.webp": 1544,
	"./live-streaming-cover.webp": 1545,
	"./lv-active-bg.webp": 1546,
	"./video-bg.webp": 1547,
	"./video-icon.webp": 1548,
	"./vs.webp": 1549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 460;